export default function (ctx) {
  const { app } = ctx
  if (window) {
    window.i18n = app.i18n
  }

  return true
}
